export function getCssRulesLength(sheet) {
  var rule = ('insertRule' in sheet) ? sheet.cssRules : sheet.rules;
  return rule.length;
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/getCssRulesLength.js